import React from 'react';

const WidgetSelector = ({ widgets, onSelect }) => {
  const handleClick = (widget) => {
    if (onSelect) {
      onSelect(widget.name); // Pass the widget name instead of the object
    } else {
      console.warn('onSelect prop is not provided');
    }
  };

  return (
    <div className="widget-selector">
      <h4 className="widget-selector-title">Select a Widget</h4>
      <ul className="widget-selector-list">
        {widgets.map((widget, index) => (
          <li
            key={index} // Use index if the widget has no unique ID
            onClick={() => handleClick(widget)} // Call handleClick with the widget object
            className="widget-selector-item"
          >
            {widget.name} {/* Display the widget name */}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WidgetSelector;
